import React from "react";
import {Form, Input, Row, Col, DatePicker, Select} from "antd";
import BeneficiaryRelationshipSelector from "components/BeneficiaryRelationshipSelector";
import {displayError, displayGenericError} from "../../common/notifications";
import {
    getCountryList, getIdType,
    getIndustryCode,
    getNationalityList,
    getOriginatorsByCustomer,
    getRelationshipCode
} from "../../api/api";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import BrdgxNationalitySelector from "../selector/BrdgxNationalitySelector";
import OriginatorsSelector from "../selector/OriginatorsSelector";
import IndustrySelector from "../selector/IndustrySelector";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import moment from "moment";
import BeneficiaryIDTypeSelector from "./BeneficiaryIDTypeSelector";

let EMAIL_MAX_LENGTH = 40;
let NAME_MIN_LENGTH = 1;
let NAME_MAX_LENGTH = 30;

class BeneficiaryInformationTab extends React.Component {
    state = {
        firstName: {
            value: ""
        },
        dob:{
            value: ""
        },
        businessRegistrationDate:{
            value: ""
        },
        lastName: {
            value: ""
        },
        idNumber: {
            value: ""
        },
        idType: {
            value: ""
        },
        email: {
            value: ""
        },
        addressLine1: {
            value: ""
        },
        industry: {
            value: ""
        },
        addressLine2: {
            value: ""
        },
        relationship: {
            value: null
        },
        businessName: {
            value: null
        },
        postalCode: {
            value: null
        },
        remark:{
            value:null
        },
        relations: [],
        countries: [],
        nationalities: [],
        country: {
            value: null
        },
        nationality: {
            value: null
        },
        selectedOriginators:{
            value:[]
        },
        contactNumber:{
            value:null
        },
        gender:{
            value:null
        },
        businessNumber:{
            value:null
        },
        originatorValidation:{},
        partnerCustomer: false,
        aliasName:{
            value:null
        },
        formerName:{
            value:null
        }
    };

    isFormValid = () => {
        if (this.state.email.validateStatus !== "success") {
            return false;
        }
        if (this.state.addressLine1.validateStatus !== "success") {
            return false;
        }
        if (this.state.relationship.validateStatus !== "success") {
            return false;
        }

        if (this.props.beneficiaryType === "INDIVIDUAL") {
            if (this.state.firstName.validateStatus !== "success") {
                return false;
            }
            if (this.state.lastName.validateStatus !== "success") {
                return false;
            }
        } else {
            if (this.state.businessName.validateStatus !== "success") {
                return false;
            }
        }
        return true;
    };

    validateName = fullName => {
        const intl = this.props.useIntl;
        if (fullName.length < NAME_MIN_LENGTH) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatorinformationtab.namelengthtooshort"}).replace('%minlength', NAME_MIN_LENGTH)
            };
        } else if (fullName.length > NAME_MAX_LENGTH) {
            return {
                validationStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatorinformationtab.namelengthtoolong"}).replace('%maxlength', NAME_MAX_LENGTH)
            };
        } else {
            return {
                validateStatus: "success",
                errorMsg: null
            };
        }
    };

    validateEmail = email => {
        // if (!email) {
        //     return {
        //         validateStatus: "error",
        //         errorMsg: "Email may not be empty"
        //     };
        // }
        const EMAIL_REGEX = RegExp("[^@ ]+@[^@ ]+\\.[^@ ]+");
        if(email !='' ){
            if (!EMAIL_REGEX.test(email)) {
                return {
                    validateStatus: "error",
                    // errorMsg: "Email not valid"
                };
            }
        }
        /*
        if (email.length > EMAIL_MAX_LENGTH) {
            return {
                validateStatus: "error",
                errorMsg: `Email is too long (Maximum ${EMAIL_MAX_LENGTH} characters allowed)`
            };
        }*/
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };
    validateDob = beneficiary => {

    }
    validateOriginator = originator => {
        const intl = this.props.useIntl;
        if (!originator || originator.length==0) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originator"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    }
    validateRelationship = relationship => {
        const intl = this.props.useIntl;
        if (!relationship) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatorinformationtab.relationship"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateIdNumber = idNumber => {
        const intl = this.props.useIntl;
        if (this.props.bankCountry === 'C048'){
            if (!idNumber) {
                return {
                    validateStatus: "error",
                    errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.cnnationalid"})
                };
            }
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateNationality = nationality => {
        const intl = this.props.useIntl;
        if (!nationality) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatormodal.nationality"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };
    validateCountry = country => {
        const intl = this.props.useIntl;
        if (!country) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatorinformationtab.country"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateAddress = address => {
        const intl = this.props.useIntl;
        if (!address) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.beneficiaryaddress"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateBusinessNature = businessNature => {
        const intl = this.props.useIntl;
        if (!businessNature) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatormodal.businessnature"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateBusinessName = businessName => {
        const intl = this.props.useIntl;
        if (this.props.beneficiaryType !== "CORPORATE") {
            return {
                validateStatus: "success",
                errorMsg: null
            };
        }
        if (!businessName) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.originatormodal.businessname"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    createBeneficiaryInformation = () => {
        return {
            firstName: this.state.firstName.value,
            lastName: this.state.lastName.value,
            email: this.state.email.value,
            address: this.state.address.value,
            relationship: this.state.relationship.value,
            businessName: this.state.businessName.value,
            idNumber: this.state.idNumber.value,
            businessRegistrationDate: this.state.businessRegistrationDate.value,
            dob: this.state.dob.value,
        };
    };

    cloneIndividualCustomer(currentCustomer) {
        const { personalAccountDetails } = currentCustomer;

        this.setState({
            firstName: {
                value: personalAccountDetails.firstName
            },
            lastName: {
                value: personalAccountDetails.lastName
            },
            addressLine1: {
                value: personalAccountDetails.addressLine1
            },
            addressLine2: {
                value: personalAccountDetails.addressLine2
            },
            country: {
                value: personalAccountDetails.countryOfResidence
            },
            nationality: {
                value: personalAccountDetails.nationality
            },
            postalCode: {
                value: personalAccountDetails.postalCode
            }
        })
    }

    cloneCorporateCustomer(currentCustomer) {
        const { corporateAccountDetails } = currentCustomer;
        this.setState({
            businessName: {
                value: corporateAccountDetails.nameOfBusiness
            },
            addressLine1: {
                value: corporateAccountDetails.addressLine1
            },
            addressLine2: {
                value: corporateAccountDetails.addressLine2
            },
            country: {
                value: corporateAccountDetails.country
            },
            postalCode: {
                value: corporateAccountDetails.postalCode
            }
        })

    }

    handleDropdownChange(name, value, validationFunction) {
        if (name == "relationship") {
            if (value == "RL03") {
                const {currentCustomer} = this.props;
                this.validateEmail(currentCustomer.email);
                if (currentCustomer.accountType == "PERSONAL" ) {
                    this.cloneIndividualCustomer(currentCustomer);
                } else if (currentCustomer.accountType == "CORPORATE" ) {
                    this.cloneCorporateCustomer(currentCustomer)
                }
            }
        }

        const selectedBeneficiary = this.props.selectedBeneficiary;
        if(selectedBeneficiary) {
            if(name==="selectedOriginators") {
                name = "originators"
            }
            if(name == "country") {
                // selectedBeneficiary.beneficiaryCountryName = value;
                selectedBeneficiary.beneficiaryCountryName = value;
                selectedBeneficiary.beneficiaryCountry = value;
            } else {
                selectedBeneficiary[name] = value;
            }
            this.props.changeSelectedBeneficiary(selectedBeneficiary)
        } else {
            this.setState({
                [name]: {
                    value: value,
                    ...validationFunction(value)
                }
            }, () => {
                    let objs = Object.fromEntries(
                        Object.entries(this.state).map(([k, v]) => [k, v.value])
                    );
                    this.props.onCompleted(objs)
                }
            );
            }
        }

    handleInputChange(event, validationFunction) {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;
        const selectedBeneficiary = this.props.selectedBeneficiary;
        if(selectedBeneficiary) {
            selectedBeneficiary[inputName] = inputValue;
           this.props.changeSelectedBeneficiary(selectedBeneficiary)
        } else {
            this.setState({
                [inputName]: {
                    value: inputValue,
                    ...validationFunction(inputValue)
                }
            }, () => {
                this.props.onCompleted(Object.fromEntries(
                    Object.entries(this.state).map(([k, v]) => [k, v.value])
                ))
            });
        }
    }

    componentDidMount() {
        getRelationshipCode().then(response => {
            this.setState({
                relations: response
            });
        }).catch(error => {
            displayGenericError(error);
        });
        getCountryList()
            .then(response => {
                this.setState({
                    countries: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });
        getNationalityList()
            .then(response => {
                this.setState({
                    nationalities: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });

        let isPartner = (this.props.currentCustomer['customerTierName'] && this.props.currentCustomer['customerTierName'].includes('PARTNER'));
        if (isPartner) {
            getOriginatorsByCustomer(this.props.currentCustomer.id).then(response => {
                this.setState({
                    partnerCustomer: true,
                    originators: response
                })
            }).catch(error => {
                displayGenericError(error);
            });
        }

        getIdType().then(response => {
            this.setState({
                idTypes: response
            });
        }).catch(error => {
            displayGenericError(error);
        });
    }

    changeBusinessNature = value => {
        let industry = this.state.industry;
        industry.value=value;
        this.setState({
            industry: industry
        })
        this.handleInputChange({
            target: {
                name:"industry",
                value: value
            }
        },this.validateBusinessNature)
    }

    render() {
        const intl = this.props.useIntl;
        const selectedBeneficiary = this.props.selectedBeneficiary;
        const selectedOriginator = this.props.selectedOriginator;
        let industryName;
        let originatorNameArr=[];
        let countryName;
        if(selectedBeneficiary) {
            let industryItem = this.props.industries.find(item => item.code === selectedBeneficiary.industry);
            if(industryItem)
                industryName = industryItem.value;

            let originators = this.props.selectedBeneficiary.originators;
            for(let originatorItem of originators) {
                let originatorName="";
                if(originatorItem.originatorType === 'CORPORATE') {
                    originatorName = originatorItem.businessName;
                } else {
                    originatorName = originatorItem.lastName + ", " + originatorItem.firstName;
                }
                originatorItem['label'] = originatorName;
                originatorNameArr.push(originatorItem);
            }
            countryName=selectedBeneficiary.beneficiaryCountry;
        }

        var defaultOriginator;
        if (selectedOriginator) {
            defaultOriginator = selectedOriginator;
            var defaultOriginatorName;
            if(selectedOriginator.originatorType === 'CORPORATE') {
                defaultOriginatorName = selectedOriginator.businessName;
            } else {
                defaultOriginatorName = selectedOriginator.lastName + ", " + selectedOriginator.firstName;
            }
            defaultOriginator['label'] = defaultOriginatorName;
            originatorNameArr.push(defaultOriginator);
            this.state.selectedOriginators.value.push(defaultOriginator);
        }

        // if (selectedOriginator){
        //     if(selectedOriginator.originatorType === 'CORPORATE') {
        //         originatorName = selectedOriginator.businessName;
        //     } else {
        //         originatorName = selectedOriginator.lastName + ", " + selectedOriginator.firstName;
        //     }
        // }
        return (
            <Form className="bp-form">
                <div className="form-content">

                    {this.props.beneficiaryType === "INDIVIDUAL" && (
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.firstname"})}
                                    validateStatus={this.state.firstName.validateStatus}
                                    help={this.state.firstName.errorMsg}
                                >
                                    <Input
                                        size={"large"}
                                        name="firstName"
                                        value={selectedBeneficiary ? selectedBeneficiary.firstName : this.state.firstName.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateName)
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.lastname"})}
                                    validateStatus={this.state.lastName.validateStatus}
                                    help={this.state.lastName.errorMsg}
                                >
                                    <Input
                                        name="lastName"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.lastName : this.state.lastName.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateName)
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.beneficiaryemail"})}
                                    validateStatus={this.state.email.validateStatus}
                                    help={this.state.email.errorMsg}
                                >
                                    <Input
                                        name="email"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.email : this.state.email.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateEmail)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.relationshipwithbeneficiary"})}
                                    validateStatus={this.state.relationship.validateStatus}
                                    help={this.state.relationship.errorMsg}
                                >
                                    <BeneficiaryRelationshipSelector
                                        // style={{ width: 300 }}
                                        size={"large"}
                                        name="relationship"
                                        relations={this.state.relations}
                                        value={selectedBeneficiary ? selectedBeneficiary.relationship : this.state.relationship.value}
                                        onChange={value =>
                                            this.handleDropdownChange(
                                                "relationship",
                                                value,
                                                this.validateRelationship
                                            )
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>)}
                    {this.props.beneficiaryType === "INDIVIDUAL" && (
                        <>
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.countryofresidence"})}
                                    validateStatus={this.state.country.validateStatus}
                                    help={this.state.country.errorMsg}
                                >

                                    <BrdgxCountrySelector
                                        placeholder={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.selectcountry"})}
                                        style={{width: '100%'}}
                                        size={"large"}
                                        name="country"
                                        countries={this.state.countries}
                                        value={countryName || this.state.country.value}
                                        onChange={country =>
                                            this.handleDropdownChange(
                                                "country",
                                                country,
                                                this.validateCountry
                                            )
                                        }

                                    />
                                </Form.Item>
                            </Col>
                            <Col md={12}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.address"})}
                                    validateStatus={this.state.addressLine1.validateStatus}
                                    help={this.state.addressLine1.errorMsg}>
                                    <Input
                                        name="addressLine1"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.addressLine1 : this.state.addressLine1.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateAddress)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.nationality"})}
                                    validateStatus={this.state.nationality.validateStatus}
                                    help={this.state.nationality.errorMsg}
                                >
                                    <BrdgxNationalitySelector
                                        style={{width: '100%'}}
                                        size={"large"}
                                        name="nationality"
                                        placeholder={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.selectnationality"})}
                                        nationalities={this.state.nationalities}
                                        value={selectedBeneficiary ? selectedBeneficiary.nationality : this.state.nationality.value}
                                        onChange={value =>
                                            this.handleDropdownChange(
                                                "nationality",
                                                value,
                                                this.validateNationality
                                            )
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.id.type"})}
                                >
                                    <BeneficiaryIDTypeSelector
                                        name={"idType"}
                                        style={{width: '100%'}}
                                        size={"large"}
                                        placeholder='Id type'
                                        value={selectedBeneficiary? selectedBeneficiary.idType : this.state.idType.value}
                                        idTypes={this.state.idTypes}
                                        onChange={(value) =>  {
                                            this.handleDropdownChange(
                                                "idType",
                                                value,
                                                ()=>{
                                                    return {
                                                        validateStatus: "success",
                                                        errorMsg: null
                                                    };
                                                }
                                            )
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.id.number"})}
                                >
                                    <Input
                                        name="idNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.idNumber : this.state.idNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, ()=>{})
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.gender"})}
                                >
                                    <Select value={selectedBeneficiary ? selectedBeneficiary.gender : this.state.gender.value}
                                            name={'gender'}
                                            size={'large'}
                                            onChange={(value) =>  {
                                                this.handleDropdownChange(
                                                    "gender",
                                                    value,
                                                    ()=>{
                                                        return {
                                                            validateStatus: "success",
                                                            errorMsg: null
                                                        };
                                                    }
                                                )
                                            }}
                                    >
                                        <Select.Option value={'MALE'}>MALE</Select.Option>
                                        <Select.Option value={'FEMALE'}>FEMALE</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.contact.number"})}
                                >
                                    <Input
                                        name="contactNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.contactNumber : this.state.contactNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, ()=>{})
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            {this.state.partnerCustomer && (
                            <Col md={12}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.senders"})}
                                    validateStatus={this.state.selectedOriginators.validateStatus}
                                    help={this.state.selectedOriginators.errorMsg}
                                >

                                    <OriginatorsSelector
                                        size={"large"}
                                        mode={"multiple"}
                                        name="selectedOriginators"
                                        originators={this.state.originators}
                                        defaultValue={originatorNameArr.length > 0 ? originatorNameArr : this.state.selectedOriginators.value}
                                        onChange={value =>
                                            this.handleDropdownChange(
                                                "selectedOriginators",
                                                value,
                                                this.validateOriginator
                                            )
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            )}
                            {this.props.bankCountry === 'C048' && (
                            <>
                            <Col md={6}></Col>
                            <Col md={6}>
                                <Form.Item
                                    required="true"
                                    hasFeedback
                                    validateStatus={this.state.idNumber.validateStatus}
                                    help={this.state.idNumber.errorMsg}
                                    label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.nationalid"})}
                                >
                                    <Input
                                        name="idNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.idNumber : this.state.idNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateIdNumber)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            </>
                            )}      
                        </Row>
                        </>
                    )}
                    {this.props.beneficiaryType === "CORPORATE" && (
                        <Row gutter={16}>
                            <Col md={12}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.businessname"})}
                                    validateStatus={this.state.businessName.validateStatus}
                                    help={this.state.businessName.errorMsg}
                                >
                                    <Input
                                        name="businessName"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.businessName : this.state.businessName.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateBusinessName)
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.beneficiaryemail"})}
                                    validateStatus={this.state.email.validateStatus}
                                    help={this.state.email.errorMsg}
                                >
                                    <Input
                                        name="email"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.email : this.state.email.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateEmail)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.relationshipwithbeneficiary"})}
                                    validateStatus={this.state.relationship.validateStatus}
                                    help={this.state.relationship.errorMsg}
                                >
                                    <BeneficiaryRelationshipSelector
                                        // style={{ width: 300 }}
                                        size={"large"}
                                        name="relationship"
                                        relations={this.state.relations}
                                        value={selectedBeneficiary ? selectedBeneficiary.relationship : this.state.relationship.value}
                                        onChange={value =>
                                            this.handleDropdownChange(
                                                "relationship",
                                                value,
                                                this.validateRelationship
                                            )
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            
                        </Row>)}
                    {this.props.beneficiaryType === "CORPORATE" && (
                        <>
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.countryofincorporation"})}
                                    validateStatus={this.state.country.validateStatus}
                                    help={this.state.country.errorMsg}
                                >

                                    <BrdgxCountrySelector
                                        placeholder={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.selectcountry"})}
                                        style={{width: '100%'}}
                                        size={"large"}
                                        name="country"
                                        countries={this.state.countries}
                                        value={countryName || this.state.country.value}
                                        onChange={country =>
                                            this.handleDropdownChange(
                                                "country",
                                                country,
                                                this.validateCountry
                                            )
                                        }

                                    />
                                </Form.Item>
                            </Col>
                            <Col md={12}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.address"})}
                                    validateStatus={this.state.addressLine1.validateStatus}
                                    help={this.state.addressLine1.errorMsg}>
                                    <Input
                                        name="addressLine1"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.addressLine1 : this.state.addressLine1.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateAddress)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.businessnature"})}
                                    validateStatus={this.state.industry.validateStatus}
                                    help={this.state.industry.errorMsg}
                                >
                                    <IndustrySelector
                                        disabled={this.props.disabled}
                                        style={{width: '100%'}}
                                        size={"large"}
                                        industries={this.props.industries}
                                        placeholder={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.selectbusinessnature"})}
                                        value={industryName || this.state.industry.value}
                                        onChange={value => this.changeBusinessNature(value)}
                                    />

                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.contact.number"})}
                                >
                                    <Input
                                        name="contactNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.contactNumber : this.state.contactNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, ()=>{})
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.business.number"})}
                                >
                                    <Input
                                        name="businessNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.businessNumber : this.state.businessNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, ()=>{})
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            {this.state.partnerCustomer && (
                            <Col md={12}>
                                <Form.Item
                                    hasFeedback
                                    required="true"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.senders"})}
                                    validateStatus={this.state.selectedOriginators.validateStatus}
                                    help={this.state.selectedOriginators.errorMsg}
                                >

                                    <OriginatorsSelector
                                        size={"large"}
                                        mode={"multiple"}
                                        name="selectedOriginators"
                                        originators={this.state.originators}
                                        defaultValue={originatorNameArr.length > 0 ? originatorNameArr : this.state.selectedOriginators.value}
                                        onChange={value =>
                                            this.handleDropdownChange(
                                                "selectedOriginators",
                                                value,
                                                this.validateOriginator
                                            )
                                        }
                                    />
                                </Form.Item>
                            </Col>)}
                            {this.props.bankCountry === 'C048' && (
                            <>
                            <Col md={6}></Col>
                            <Col md={6}>
                                <Form.Item
                                    required="true"
                                    hasFeedback
                                    validateStatus={this.state.idNumber.validateStatus}
                                    help={this.state.idNumber.errorMsg}
                                    label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.nationalid"})}
                                >
                                    <Input
                                        name="idNumber"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.idNumber : this.state.idNumber.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateIdNumber)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            </>
                            )} 
                        </Row>
                        <Row gutter={16}>
                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="false"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.firstname.norequired"})}
                                    validateStatus={this.state.firstName.validateStatus}
                                    help={this.state.firstName.errorMsg}
                                >
                                    <Input
                                        size={"large"}
                                        name="firstName"
                                        value={selectedBeneficiary ? selectedBeneficiary.firstName : this.state.firstName.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateName)
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col md={6}>
                                <Form.Item
                                    hasFeedback
                                    required="false"
                                    label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.lastname.norequired"})}
                                    validateStatus={this.state.lastName.validateStatus}
                                    help={this.state.lastName.errorMsg}
                                >
                                    <Input
                                        name="lastName"
                                        size={"large"}
                                        value={selectedBeneficiary ? selectedBeneficiary.lastName : this.state.lastName.value}
                                        onChange={event =>
                                            this.handleInputChange(event, this.validateName)
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item  label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.dob.norequired"})}>
                                    <DatePicker
                                        placeholder="YYYY-MM-DD"
                                        style={{width: '100%'}}
                                        size={"large"}
                                        value={
                                            selectedBeneficiary ? (selectedBeneficiary.dob
                                                ? moment(selectedBeneficiary.dob)
                                                : null) : (this.state.dob.value ?  moment(this.state.dob.value) : null)
                                        }
                                        disabled={this.props.disabled}
                                        onChange={(newValue, newValueStr) =>
                                            this.handleDropdownChange(
                                                "dob",
                                                newValueStr,
                                                this.validateDob
                                            )
                                        }


                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        </>
                    )}
                    <Row gutter={16}>
                        <Col md={6}>
                            <Form.Item
                                hasFeedback
                                required="true"
                                label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.postal.code"})}
                                >
                                <Input
                                    name="postalCode"
                                    size={"large"}
                                    value={selectedBeneficiary ? selectedBeneficiary.postalCode : this.state.postalCode.value}
                                    onChange={event =>
                                        this.handleInputChange(event, ()=>{})
                                    }
                                />
                            </Form.Item>
                        </Col>
                        {this.props.beneficiaryType === "INDIVIDUAL" && (
                        <Col md={6}>
                            <Form.Item  label={intl.formatMessage({id: "app.modal.beneficiarymodal.dateofbirth"})}>
                                <DatePicker
                                    // format={"YYYY/MM/DD"}
                                    placeholder="YYYY-MM-DD"
                                    style={{width: '100%'}}
                                    size={"large"}
                                    value={
                                        selectedBeneficiary ? (selectedBeneficiary.dob
                                            ? moment(selectedBeneficiary.dob)
                                            : null) : (this.state.dob.value ?  moment(this.state.dob.value) : null)
                                    }
                                    disabled={this.props.disabled}
                                    onChange={(newValue, newValueStr) =>
                                        this.handleDropdownChange(
                                            "dob",
                                            newValueStr,
                                            this.validateDob
                                        )
                                    }


                                />
                            </Form.Item>
                        </Col>)}
                        {this.props.beneficiaryType === "CORPORATE" && (
                            <Col md={6}>
                                <Form.Item  label={intl.formatMessage({id: "app.modal.beneficiarymodal.businessRegistrationDate"})}>
                                    <DatePicker
                                        // format={"YYYY/MM/DD"}
                                        placeholder="YYYY-MM-DD"
                                        style={{width: '100%'}}
                                        size={"large"}
                                        value={
                                            selectedBeneficiary ? (selectedBeneficiary.businessRegistrationDate
                                                ? moment(selectedBeneficiary.businessRegistrationDate)
                                                : null) : (this.state.businessRegistrationDate.value ?  moment(this.state.businessRegistrationDate.value) : null)
                                        }
                                        disabled={this.props.disabled}
                                        onChange={(newValue, newValueStr) =>
                                            this.handleDropdownChange(
                                                "businessRegistrationDate",
                                                newValueStr,
                                                this.validateDob
                                            )
                                        }


                                    />
                                </Form.Item>
                            </Col>)}
                        <Col md={12}>
                            <Form.Item
                                hasFeedback
                                required="true"
                                label={intl.formatMessage({id: "app.modal.beneficiaryinformationtab.remarks"})}>
                                <Input
                                    name="remark"
                                    size={"large"}
                                    value={selectedBeneficiary ? selectedBeneficiary.remark :  this.state.remark.value}
                                    onChange={event =>
                                        this.handleInputChange(event, ()=>{})
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                    <Col md={6}>
                        <Form.Item
                            hasFeedback
                            required="true"
                            label="Alias Name"
                        >
                            <Input
                                name="aliasName"
                                size={"large"}
                                value={selectedBeneficiary ? selectedBeneficiary.aliasName : this.state.aliasName.value}
                                onChange={event =>
                                    this.handleInputChange(event, ()=>{})
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item
                            hasFeedback
                            required="true"
                            label="Former Registered Name"
                        >
                            <Input
                                name="formerName"
                                size={"large"}
                                value={selectedBeneficiary ? selectedBeneficiary.formerName : this.state.formerName.value}
                                onChange={event =>
                                    this.handleInputChange(event, ()=>{})
                                }
                            />
                        </Form.Item>
                    </Col>
                    </Row>

                </div>
            </Form>
        );
    }
}

export default withUseIntl(BeneficiaryInformationTab);